import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import styled from 'styled-components';
import * as types from '../../lib/constants';
import { isGeneral } from '../../lib/tools';
import {
  restoreWorkRecords,
  deleteWorkRecords,
  updateSearchOptions,
  updateExecuteEvent,
  clickUnsetTagOnlyCheckBox,
  clickToolBarCheckBox,
  clickListCheckBox,
  selectPage,
  ActionTypes as TrashActionTypes,
} from '../../actions/trash';
import HeaderNotice from '../Parts/HeaderNotice';
import Block from '../../styles/common/Block';
import Title from '../../styles/common/Title';
import leftAllowIcon from '../../images/common/ic_arrow_left.svg';
import TimeLineSearchBox from '../TimeLine/TimeLineSearchBox';
import TimeLineToolBar from '../TimeLine/TimeLineToolBar';
import TimeLineGridLists from '../TimeLine/TimeLineGridLists';
import TimeLinePagenation from '../TimeLine/TimeLinePagenation';
import getMultiLevelTags from '../../actions/api/tag/getMultiLevelTags';
import TagSearchDialog from '../TimeLine/TagSearchDialog';
import useTagSearchDialog from '../../hooks/useTagSearchDialog';

const TrashTitle = styled(Title)`
  & img {
    margin-right: 10px;
  }
`;
const ListBase = styled.div`
  height: ${props =>
    (props.searchBoxHeight && `calc(100% - ${props.searchBoxHeight}px)`) ||
    '100%'};
`;

const style = {
  link: {
    display: 'flex',
  },
};

const TrashPage = ({
  searchBoxHeight,
  apiToken,
  dispatch,
  innerRole,
  redirect,
  trashInfo,
  flatTags,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const targetGroupId = useSelector(state => state.main.targetGroupId);

  const { showTagSearchDialog, toggleTagSearchDialog, closeTagSearchDialog } =
    useTagSearchDialog();

  const isGeneralUser = isGeneral(innerRole);
  const {
    timelines,
    searchOptions,
    searchOptionsError,
    selectOptions,
    checkbox,
    executeEvent,
    selectedTagIds,
    pagenation,
  } = trashInfo;

  return (
    <Block>
      <HeaderNotice msg={formatMessage({ id: 'trash.headerNotice' })} />
      <TrashTitle id="title">
        <Link to="/ds/timeline" style={style.link}>
          <img src={leftAllowIcon} alt="trashOnOpenTimelineIcon" />
        </Link>
        <label>
          <FormattedMessage id="trash.title" />
        </label>
      </TrashTitle>
      <TimeLineSearchBox
        searchOptions={searchOptions}
        searchOptionsError={searchOptionsError}
        tags={selectOptions.tags}
        selectedTagIds={selectedTagIds}
        onSearch={option => updateSearchOptions(dispatch, option)}
        isGeneralUser={isGeneralUser}
        onCheck={checked => clickUnsetTagOnlyCheckBox(dispatch, checked)}
        isShowSaveSearchCriteria={false}
        isSearchForUnsetTagOnly={searchOptions.isSearchForUnsetTagOnly}
        hideGroupSelection
        flatTags={flatTags}
        searchTags={() =>
          dispatch(
            getMultiLevelTags(
              apiToken,
              {
                actionType: TrashActionTypes.SUCCESS_API_GET_ALL_TAGS,
                all: true,
              },
              targetGroupId,
            ),
          )
        }
        initialTagsForSearch={() =>
          dispatch({ type: TrashActionTypes.CLOSE_TAG_SEARCH_DIALOG })
        }
        setTags={params => {
          dispatch({
            type: TrashActionTypes.SEARCHBOX_UPDATE_SEARCH_TAGS,
            params,
          });
          dispatch({
            type: TrashActionTypes.CLICK_UNSET_TAG_ONLY_CHECKBOX,
            checked: false,
          });
        }}
        onChangeDisplayTag={params => {
          dispatch({ type: 'CHANGE_DISPLAY_TAG', params });
        }}
        toggleTagSearchDialog={toggleTagSearchDialog}
      />
      <TimeLineToolBar
        innerRole={innerRole}
        checkbox={checkbox}
        executeEvent={executeEvent}
        dispatch={dispatch}
        timelines={timelines}
        timeLineScreenMode={types.TIMELINE_SCREEN_MODE.grid}
        onCheck={(value, checked) =>
          clickToolBarCheckBox(dispatch, value, checked)
        }
        onUpdateExecuteEvent={e => updateExecuteEvent(dispatch, e.target.value)}
        onRestoreClick={workRecordIds => {
          if (checkbox.ids.length > 0) {
            restoreWorkRecords(
              dispatch,
              apiToken,
              formatMessage,
              null,
              workRecordIds,
            );
          }
        }}
        onCompleteDeleteClick={workRecordIds => {
          if (checkbox.ids.length > 0) {
            deleteWorkRecords(
              dispatch,
              apiToken,
              formatMessage,
              null,
              workRecordIds,
            );
          }
        }}
        isShowRestore
        isShowCompleteDelete
      />
      <ListBase searchBoxHeight={searchBoxHeight}>
        <TimeLineGridLists
          openDetail={id => {
            redirect(`/trash/media/${id}`);
          }}
          innerRole={innerRole}
          fullscreen
          timelines={timelines}
          searchOptions={searchOptions}
          checkbox={checkbox}
          onCheck={(value, checked) =>
            clickListCheckBox(dispatch, value, checked)
          }
        />
      </ListBase>
      <TimeLinePagenation
        pagenation={pagenation}
        searchOptions={searchOptions}
        onSelect={page => {
          clickListCheckBox(dispatch, 'all', false);
          selectPage(dispatch, page);
        }}
      />
      {showTagSearchDialog && (
        <TagSearchDialog
          tags={flatTags}
          selectedTagIds={selectedTagIds}
          onClose={() => closeTagSearchDialog()}
          select={params => {
            dispatch({ type: 'SEARCHBOX_UPDATE_SEARCH_TAGS', params });
            dispatch({
              type: 'TIMELINESEARCHBOX_CHECKBOX_CHECK',
              checked: false,
            });
            closeTagSearchDialog();
          }}
        />
      )}
    </Block>
  );
};

TrashPage.propTypes = {
  searchBoxHeight: PropTypes.number.isRequired,
  apiToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  innerRole: PropTypes.number.isRequired,
  redirect: PropTypes.func.isRequired,
  trashInfo: PropTypes.object.isRequired,
  flatTags: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  trashInfo: state.trash.trashInfo,
  flatTags: state.trash.flatTags,
});

export default connect(mapStateToProps)(TrashPage);
